export default __webpack_public_path__ + "static/media/1023.c0f98133.svg";